import { render, staticRenderFns } from "./Maintext.vue?vue&type=template&id=37c13a50&scoped=true&"
import script from "./Maintext.vue?vue&type=script&lang=js&"
export * from "./Maintext.vue?vue&type=script&lang=js&"
import style0 from "./Maintext.vue?vue&type=style&index=0&id=37c13a50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c13a50",
  null
  
)

export default component.exports